enum Sort {
  RELEVANCE = 'RELEVANCE',
  TITLE_ASC = 'TITLE_ASC',
  TITLE_DES = 'TITLE_DES',
  DATE_ASC = 'DATE_ASC',
  DATE_DES = 'DATE_DES',
  LAST_EDITED_ASC = 'LAST_EDITED_ASC',
  LAST_EDITED_DES = 'LAST_EDITED_DES',
}

export default Sort;

export const isSort = (x: any): x is Sort => Object.keys(Sort).includes(x);
